export const consoleError = (error: any) => {
  console.log(`Error!`, error)
}
